<template>
    <div class="weekMonthBlock-wrap">
        <profit-line></profit-line>
        <profit-invest :typeProfit="'pointInvest'"></profit-invest>
        <profit-invest :typeProfit="'pointLine'" :title="'Доход инвестора ср./мес'"></profit-invest>
        <profit-invest :typeProfit="'pointYear'" :title="'Доход инвестора ср./год'"></profit-invest>
    </div>
</template>
<script>
import ProfitLine from './profit-line-widget';
import InvestProfit from './profir-line-widget-invest';
export default {
   components: {
       'profit-line':ProfitLine,
       'profit-invest' :InvestProfit
   }

}
</script>
<style lang="less" scoped>
.weekMonthBlock {
    &-wrap {
        background: #324258;
        border-radius: 8px;
    }
    &-title {
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 3;
        letter-spacing: 0.4px;
        color: #fff;
        margin-left: 16px;
    }
}
</style>